import React from 'react';
import { useState, useEffect } from 'react';
import { Link, useHistory } from 'react-router-dom';
import ChooseUserOption from '../chooseUserOption/chooseUserOption';
import "./chooseUserSelect.css"
import CustomButtons from '../../../../components/Elements/Buttons/customButton';
import CustomTittle from '../../../../components/Elements/customTittle/customTittle';




 
const ChooseUserSelect = (props) => {


    
   function addPerson (){
    props.showModal()
   } 
   function reletedPerson (id,fullOption){
  
    if(fullOption != undefined){
    props.onCheck(id, true, fullOption)}else{
        props.onCheck(id, true, null)
    }
   }

   function payerPerson (id,fullOption){
  
    if(fullOption != undefined){
    props.setPayer(id, true, fullOption)}else{
        props.setPayer(id, true, null)
    }
   }
  

    return <> 
 <div className='iconTitleLabel'>
    <div  className='iconTitleWrapper'>
    {
        props.isRelatedPerson?
        <svg xmlns="http://www.w3.org/2000/svg" className="iconChecked" fill="#cc0033"  viewBox="0 0 36 36"><path strokeWidth="5" d="M16 0a16 16 0 1 0 16 16A16 16 0 0 0 16 0zm0 30a14 14 0 1 1 14-14 14 14 0 0 1-14 14z"/><path d="m13 20.59-4.29-4.3-1.42 1.42 5 5a1 1 0 0 0 1.41 0l11-11-1.41-1.41z"/></svg>:
        <svg xmlns="http://www.w3.org/2000/svg" className="iconTitle" fill="#e6e6e6"  viewBox="0 0 36 36"><path  d="M16 0a16 16 0 1 0 16 16A16 16 0 0 0 16 0zm0 30a14 14 0 1 1 14-14 14 14 0 0 1-14 14z"/></svg>
    } </div>
        <label>{props.label}</label>
    </div>
    <div className='iconSelectOption'>
    {props.option.map((option)=>{
        
        if(option.active == 1) {
        return <ChooseUserOption option={option} userName={option.firstName + " " + option.lastName} onCheck={reletedPerson} isChekcked={props.selectUsersId == option.usersID}  idUsers={option.usersID} label={option.firstName + " " + option.lastName}></ChooseUserOption>}
        else{
            return <div className='unActivetedPerson' title="Osoba powiązana nie została jeszcze aktywowana."><div className='unActivetedPerson_svg'><svg xmlns="http://www.w3.org/2000/svg" className="iconTitle" fill="#e6e6e6"  viewBox="-4 0 36 36"><path  d="M16 0a16 16 0 1 0 16 16A16 16 0 0 0 16 0zm0 30a14 14 0 1 1 14-14 14 14 0 0 1-14 14z"/></svg></div> <p>{option.firstName + " " + option.lastName}</p></div>
        }})}
    </div>
    {/* props.isAdult właściwa zależność */}
    {false?<div>
        <CustomTittle>Wybierz opiekanu lub rodzica</CustomTittle>
        <p className='forWho'>Ponieważ jesteś osobą niepełnoletnią koniecznym będzie dodanie osoby powiązanej - Twojego rodzica lub opiekuna, aby mógł sfinalozwać zakup Twojego kursu.</p>
        <div className='iconSelectOption'>
        {props.option.map((option)=>{
        
            
        if(!option.adult) {
        return <ChooseUserOption option={option} userName={option.firstName + " " + option.lastName} onCheck={payerPerson} isChekcked={props.selectPayerId == option.usersID}  idUsers={option.usersID} label={option.firstName + " " + option.lastName}></ChooseUserOption>
}})}
</div>
        </div>:""}
    <CustomButtons clickFunction={addPerson}  classButton="outline" size="big">+ DODAJ OSOBĘ POWIĄZANĄ</CustomButtons>
    <p className='TextWithDot' title='Osoba powiązana to osoba małoletnia, która jest Uczestnikiem i w imieniu której jej opiekun prawny zawarł Umowę'>Kto to jest osoba powiązana <p className='hintTextDot'>?</p></p>
    
    </>;
    }

export default ChooseUserSelect;
